import { Component } from 'react';
import qs from 'qs';
import urlJoin from 'proper-url-join';

class AuthorizationRedirect extends Component<AuthorizationRedirectProps, {}> {
  componentDidMount() {
    const { clientId, locationPathname, locationSearch } = this.props;
    const redirectUri = `${window.location.origin}${locationPathname}`;
    const authorizationSearchParams = qs.stringify(
      {
        response_type: 'code',
        client_id: clientId,
        redirect_uri: redirectUri,
        state: locationSearch
      },
      { addQueryPrefix: true }
    );
    const authorizationEndpoint = '/v2/oauth2/authorize';
    const authorizationUrl = urlJoin(authorizationEndpoint, authorizationSearchParams);

    window.location.assign(authorizationUrl);
  }

  render() {
    return null;
  }
}

export default AuthorizationRedirect;
